<template>  
    <mu-appbar class="XR-edit-head" :title="titleText">
        <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
        <mu-flat-button v-if="rightButtonShow" v-on:click="RightButonClick()" :label="rightButtonShowTextValue" slot="right"/>
    </mu-appbar>
</template>

<script>
export default {
  name : 'XR-edit-head',
  data () {
    return {
      mode : 'complete',
      rightButtonTextValue: this.rightButtonText ? this.rightButtonText : '编辑',
      rightButtonShowTextValue: this.rightButtonText ? this.rightButtonText : '编辑'
    }
  },
  props:{
    titleText:String,
    rightButtonShow: Boolean,
    rightButtonText:String
  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
    RightButonClick(){
      
      if(this.mode == 'complete'){
        this.mode = 'edit'
        this.$emit("editEvent")
      }
      else if(this.mode == 'edit'){
        this.mode = 'complete'
        this.$emit("completeEvent") 
      }

      if(this.mode == 'complete'){
        this.rightButtonShowTextValue = this.rightButtonTextValue
      }
      else if(this.mode == 'edit'){
        this.rightButtonShowTextValue = '完成'
      }
    }
  }
}
</script>

<style>
.XR-edit-head .mu-appbar{
  height: 46px;
  text-align: center;
}
.XR-edit-head .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.XR-edit-head .mu-appbar-title {
  font-size: 16px;
}
.XR-edit-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.XR-edit-head .title .title-text {
  margin: 0;
  line-height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/usercenter/editHead/editHead.vue